export enum TrackingSourceEnum {
  Google = 1,
  Direct = 2,
  Newsletter = 3,
  Bing = 4,
  Content = 5,
  Adstraction = 6,
  Facebook = 10,
}
